import styled, { css } from "styled-components";

export const FocusedWrapper = styled("div")<{ fullscreen: boolean }>`
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 0px 8px rgb(0, 0, 0, 0.4);
  backdrop-filter: blur(1.5px);
  -webkit-backdrop-filter: blur(1.5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  ${(props) =>
    props.fullscreen
      ? css`
          position: fixed;
          top: 0;
          left: 0;
          width: 100% !important;
          height: 100%;
          max-height: 100% !important;
          z-index: 9999;
          margin: 0;
          border-radius: 0;
        `
      : css`
          &:hover #focused-fullscreen {
            display: flex;
          }
        `}

  @container (min-width: 1200px) {
    width: 90%;
  }
`;

interface IFocusedVideo {
  isScreen: boolean;
}

export const FocusedVideo = styled("video")<IFocusedVideo>`
  z-index: 1;
  width: fit-content;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  display: ${(props) => (props.hidden ? "none" : "initial")};
  ${(props) => {
    if (props.isScreen) {
      return css`
        max-width: 100%;
        max-height: 100%;
        position: relative;
        object-fit: contain;
      `;
    }
    return "";
  }}
  @container (max-width: 675px) {
    width: 100%;
  }
`;
